<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-09-27 17:00:27
 * @LastEditors: Please set LastEditors
-->
<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-spin :spinning="loading">
        <a-form :form="form">
          <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['title', { rules: [{ required: true, message: '请输入标题' }] }]"
              placeholder="请输入标题"
            />
          </a-form-item>
          <a-form-item label="英文标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['title_en', { rules: [{ required: true, message: '请输入英文标题' }] }]"
              placeholder="请输入英文标题"
            />
          </a-form-item>
          <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
            <a-textarea
              rows="4"
              name="keywords"
              placeholder="请输入标签"
              v-decorator="['keywords', { rules: [{ required: true, message: '请输入标签' }] }]"
            />
          </a-form-item>
          <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea
              rows="4"
              name="description"
              placeholder="请输入简介"
              v-decorator="['description', { rules: [{ required: true, message: '请输入简介' }] }]"
            />
          </a-form-item>
          <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-spin :spinning="categoriesLoad">
              <a-select
                placeholder="请选择分类"
                style="width: 100%"
                name="cat_id"
                optionFilterProp="children"
                allow-clear
                v-decorator="['cat_id', { rules: [{ required: true, message: '请选择分类' }] }]"
              >
                <a-select-option v-for="cat in categoriesLists" :key="cat.id">{{
                  cat.name
                }}</a-select-option>
              </a-select>
            </a-spin>
          </a-form-item>

          <a-form-item label="缩略图" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <img-upload
              name="thumb"
              v-decorator="['thumb', { rules: [{ required: true, message: '请上传缩略图' }] }]"
            />
          </a-form-item>
          <a-form-item
            label="开课时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            v-if="selectMode === '3'">
            <a-date-picker
              showTime
              placeholder="请选择开课时间"
              format="YYYY-MM-DD HH:mm:ss"
              v-decorator="['deadline',{ rules: [{ required: true, message: '请选择开课时间' }] }]"
            />
          </a-form-item>
          <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
            <u-editor
              v-decorator="['contents', { rules: [{ required: true, message: '请输入介绍' }] }]"
            />
          </a-form-item>

          <a-form-item label="购买价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              name="price"
              :min="0"
              v-decorator="[
                'price',
                {
                  initialValue: 0,
                  rules: [{required: true, message: '请输入正确的价格' }]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="章节数" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              name="nums"
              v-decorator="[
                'nums',
                {
                  initialValue: 0
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="时长" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              name="hours"
              v-decorator="[
                'hours',
                {
                  initialValue: 0
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
            <a-input-number
              name="sort"
              v-decorator="[
                'sort',
                {
                  initialValue: 0
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            label="状态"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            help="是否在前端展示，默认展示"
          >
            <a-switch
              checked-children="展示"
              un-checked-children="隐藏"
              name="state"
              v-decorator="[
                'state',
                {
                  valuePropName: 'checked',
                  initialValue: true
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            :wrapperCol="{
              lg: { span: 14, offset: 8 },
              md: { span: 14, offset: 8 },
              sm: { span: 14, offset: 8 },
              xs: { span: 24 }
            }"
            style="text-center: center"
          >
            <a-button
              icon="plus"
              :loading="formLoading"
              @click="handleSubmit(setFormValues)"
              type="primary"
            >提交</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form, select } from '@/mixins' // 引入
import { ImgUpload, FileUpload, UEditor, GoBack } from '@/components'

const apiList = {
    create: '/courses/create',
    update: '/courses/',
    coursesCategoriesList: '/courses/categories/select',
    getInfo: '/courses/'
}
const fields = [
    'title',
    'title_en',
    'keywords',
    'thumb',
    'description',
    'contents',
    'price',
    'is_baidu',
    'dir',
    'video_id',
    'sort',
    'nums',
    'organization',
    'deadline',
    'hours',
    'state',
    'cat_id',
    'allow_buy'
]

export default {
    name: 'CourseForm',
    mixins: [form, select], // 使用mixins
    components: {
        ImgUpload,
        FileUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            selectMode: '', // 上课模式
            categoriesLists: [],
            categoriesLoad: false
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.state = values.state === 1 // 状态格式转换
                values.allow_buy = values.allow_buy === 1 // 状态格式转换
                values.price = values.price / 100 // 状态格式转换
                values.is_baidu = values.is_baidu.toString()
                that.selectMode = values.is_baidu.toString()
            })
        }
        that.getSelectLists({
            url: apiList.coursesCategoriesList,
            type: 'categoriesLists',
            load: 'categoriesLoad'
        })
    },
    methods: {
        /**
         * 选择上课模式
         * @param
         *  {value}
         */
        handleSelectMode (key) {
            this.selectMode = key
        },
        /**
         * 整理form表单提交数据
         * @jdy
         * @2021-4-15
         */
        setFormValues (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
            values.allow_buy = values.allow_buy ? 1 : 2 // 状态 1正常 2隐藏
        }
    }
}
</script>
